import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest?._retry && !originalRequest?.skipAuthRefresh && !originalRequest?.url?.includes("/auth/login")) {
      originalRequest._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(originalRequest);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}


export function adminFileUrl(path) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/admin/file?path=${encodeURIComponent(path)}`;
}

export function articleImageUrl(path) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/public-file?path=${encodeURIComponent(path)}`;
}
